import styled, { css } from 'styled-components';

const sizeStyles = {
	small: css`
    padding: 3px 6px;
    font-size: 12px;
  `,
	medium: css`
    padding: 5px 10px;
    font-size: 14px;
  `,
	large: css`
    padding: 7px 11px;
    font-size: 16px;
  `,
};

const ToggleButtonStyle = styled.button<{ isActive: boolean, size: 'small' | 'medium' | 'large' }>`
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: ${({ isActive }) => (isActive ? 'var(--primary)' : 'var(--defaultBgColor)')};
  color: ${({ isActive }) => (isActive ? 'var(--btnLabel)' : 'var(--textColor)')};
  cursor: pointer;
  transition: all 0.3s ease;
	// min-width: 50px;
	${({ size }) => sizeStyles[size]}

  &:hover {
    background-color: ${({ isActive }) => (
		isActive ? 'color-mix(in srgb, var(--primary) 85%, black)' : 'var(--controlHoverBgColor)'
	)};
  }
`;

const ToggleGroupContainerStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
	flex-wrap: wrap;
	justify-content: flex-start;
  align-content: flex-start;
  max-width: 100%;
	input {
		width: 66px; 
		height: 29px;
		border: 1px solid var(--primary);
    border-radius: 4px;
    padding-left: 6px;
		color: rgba(46, 56, 77, .9);
			color: var(--primary);

		&:active,
		&:focus{
			border-color: var(--primary);
			color: var(--primary);
			box-shadow: none;
			outline: none;
		}
		&.active{
			border-color: var(--primary);
			color: var(--primary);
		}	
	}
`;

export { ToggleButtonStyle, ToggleGroupContainerStyle };
